 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","boat":"boat","booking":"booking","complaint":"complaint","printhotelvoucher":"printhotelvoucher","printitinerary":"printitinerary","printrestaurantvoucher":"printrestaurantvoucher","driver":"driver","employees":"employees","itinerary":"itinerary","notfound":"notfound","rolemanagement":"rolemanagement","useraccount":"useraccount","tourguide":"tourguide","transportation":"transportation","bookingarrivalinfo":"bookingarrivalinfo","bookingitineraryinfo":"bookingitineraryinfo","bookingoptionaltour":"bookingoptionaltour","bookingrestaurant":"bookingrestaurant","bookingtourguide":"bookingtourguide","bookingtransport":"bookingtransport","loadingdataerror":"loadingdataerror"}[chunkId]||chunkId) + "." + {"about":"1aef2389","boat":"a1397f99","chunk-260e8bb6":"76d6daff","chunk-2af993c2":"50727d64","chunk-419c0254":"bac94691","chunk-2d0c9aaf":"0f645b1f","booking":"88853c1c","complaint":"891c8e6c","printhotelvoucher":"d7609d8b","printitinerary":"c6405f30","printrestaurantvoucher":"fea74b07","chunk-de5e6068":"1a614780","chunk-4da2ca3a":"d9f409eb","driver":"1db7790d","employees":"c9747d57","itinerary":"a5389f5b","notfound":"e1b3445b","rolemanagement":"481b9a2e","useraccount":"10449f48","tourguide":"36d8c11a","transportation":"723c1573","chunk-0abdffda":"935fb640","chunk-0f58ee74":"5b86251a","chunk-118baa39":"3e538d79","chunk-91813246":"40063f83","chunk-0517e2fb":"f3c5d228","chunk-50645b4b":"ead003ac","bookingarrivalinfo":"fc77786a","bookingitineraryinfo":"9f1b8d84","bookingoptionaltour":"98526a9c","bookingrestaurant":"c30700e7","bookingtourguide":"43ec1a47","bookingtransport":"2757a478","chunk-9cca8eb6":"e834f5ac","loadingdataerror":"f8e0eb45"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"boat":1,"chunk-260e8bb6":1,"booking":1,"complaint":1,"printhotelvoucher":1,"printitinerary":1,"printrestaurantvoucher":1,"chunk-de5e6068":1,"chunk-4da2ca3a":1,"driver":1,"employees":1,"itinerary":1,"rolemanagement":1,"useraccount":1,"tourguide":1,"transportation":1,"chunk-0abdffda":1,"chunk-0f58ee74":1,"chunk-118baa39":1,"chunk-91813246":1,"chunk-0517e2fb":1,"chunk-50645b4b":1,"bookingarrivalinfo":1,"bookingitineraryinfo":1,"bookingrestaurant":1,"bookingtourguide":1,"bookingtransport":1,"chunk-9cca8eb6":1,"loadingdataerror":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","boat":"boat","booking":"booking","complaint":"complaint","printhotelvoucher":"printhotelvoucher","printitinerary":"printitinerary","printrestaurantvoucher":"printrestaurantvoucher","driver":"driver","employees":"employees","itinerary":"itinerary","notfound":"notfound","rolemanagement":"rolemanagement","useraccount":"useraccount","tourguide":"tourguide","transportation":"transportation","bookingarrivalinfo":"bookingarrivalinfo","bookingitineraryinfo":"bookingitineraryinfo","bookingoptionaltour":"bookingoptionaltour","bookingrestaurant":"bookingrestaurant","bookingtourguide":"bookingtourguide","bookingtransport":"bookingtransport","loadingdataerror":"loadingdataerror"}[chunkId]||chunkId) + "." + {"about":"31d6cfe0","boat":"2edf07d1","chunk-260e8bb6":"de3cc5f1","chunk-2af993c2":"31d6cfe0","chunk-419c0254":"31d6cfe0","chunk-2d0c9aaf":"31d6cfe0","booking":"a0ff616d","complaint":"c39e9ee4","printhotelvoucher":"d5f8ea8b","printitinerary":"bfd69875","printrestaurantvoucher":"465ccf7b","chunk-de5e6068":"16418c27","chunk-4da2ca3a":"a088aa29","driver":"086fc7ca","employees":"732d002f","itinerary":"1a1aeddd","notfound":"31d6cfe0","rolemanagement":"7347ca5d","useraccount":"ae1920d1","tourguide":"ad91f322","transportation":"5c305119","chunk-0abdffda":"b47895dd","chunk-0f58ee74":"52f1f53f","chunk-118baa39":"6ca0b6f3","chunk-91813246":"5a559311","chunk-0517e2fb":"4464dac5","chunk-50645b4b":"6dccf481","bookingarrivalinfo":"622e2549","bookingitineraryinfo":"7fefa7c2","bookingoptionaltour":"31d6cfe0","bookingrestaurant":"7fefa7c2","bookingtourguide":"7fefa7c2","bookingtransport":"7fefa7c2","chunk-9cca8eb6":"7fefa7c2","loadingdataerror":"7fefa7c2"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
